import { InjectionToken } from '@angular/core';
import { SiteWideLinkTags } from './link-tags.interface';

export const SITE_WIDE_LINK_TAGS = new InjectionToken<SiteWideLinkTags>(
  'SiteWideLinkTagsConfig',
);
